import HttpRequest from "@/util/HttpRequest";

const KEY_HOME_NOTIFICATION = "home_notification";

// 서버마다 켜고 끄는 기능 목록 (MaotConfig key = 'enabled_features')
const KEY_ENABLED_FEATURES = "enabled_features";

// 아래 hide_* 키는 반대로 "켜면 숨긴다". 키가 없는 서버는 지금처럼 보인다.
// 상단 네비바의 언어 선택
export const FEATURE_HIDE_LANGUAGE_SELECT = "hide_language_select";

export default {
  namespaced: true,
  state: {
    homeNotification: {},
    // null = 아직 조회 전
    enabledFeatures: null,
  },
  mutations: {
    LOAD_HOME_NOTIFICATION(state, data) {
      state.homeNotification = JSON.parse(data.config);
    },

    LOAD_ENABLED_FEATURES(state, data) {
      state.enabledFeatures = data;
    },
  },
  actions: {
    // 결재 요청함 추가/수정
    // * 1108에서 사용가능하도록 KEY 수정
    async SAVE_HOME_NOTIFICATION({ commit }, params) {
      // boardSlug = '' 인 경우 모든 게시판에 대해서 가져온다.
      let key = KEY_HOME_NOTIFICATION;
      if (params.key) key = params.key;

      const option = {
        key,
        config: JSON.stringify(params.config),
      };
      return new Promise((resolve, reject) => {
        HttpRequest.post("/api/v1/config", option)
          .then((response) => {
            commit("LOAD_HOME_NOTIFICATION", response);
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    },

    // 결재 요청함 불러오기
    async LOAD_HOME_NOTIFICATION({ commit }, params) {
      let key = KEY_HOME_NOTIFICATION;
      if (params.key) key = params.key;

      // boardSlug = '' 인 경우 모든 게시판에 대해서 가져온다.
      const option = {
        params: {
          key,
        },
      };
      return new Promise((resolve, reject) => {
        HttpRequest.get("/api/v1/config", option)
          .then((response) => {
            commit("LOAD_HOME_NOTIFICATION", response);
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    },

    /**
     * 서버에서 켜져 있는 기능 목록을 조회한다.
     * 화면이 열릴 때마다 부르지 않도록 세션 중 한 번만 조회하고 store 에 담아둔다.
     *
     * @returns {Promise<boolean>} 해당 기능이 켜져 있으면 true
     */
    async IS_FEATURE_ENABLED({ commit, state, dispatch }, feature) {
      let features = state.enabledFeatures;

      if (features === null) {
        try {
          // 설정이 없는 서버가 대부분이라 404 가 정상이다. 오류 알림을 띄우지 않는다.
          features = await dispatch("LOAD_CONFIG", { key: KEY_ENABLED_FEATURES, notWarn: true });
        } catch (e) {
          features = undefined;
        }
        // 조회에 실패했거나 값이 없어도 재요청하지 않도록 빈 값으로 확정한다.
        features = features || [];
        commit("LOAD_ENABLED_FEATURES", features);
      }

      if (Array.isArray(features)) return features.includes(feature);
      return Boolean(features[feature]);
    },

    /**
     * MaotConfig 모델에서 조회한다
     *
     * @param {Object} params
     * @param {String} params.key
     * @param {Boolean} [params.notWarn] 값이 없는 것이 정상인 조회에 쓴다.
     *   설정이 없으면 서버가 404 를 주는데, 기본값으로 두면 공통 오류 알림이 사용자에게 그대로 뜬다.
     */
    async LOAD_CONFIG({}, params) {
      const option = {
        params: {
          key: params.key,
        },
      };
      return new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/config`, option, params.notWarn)
          .then((response) => {
            try {
              const config = JSON.parse(response.config);
              resolve(config);
            } catch (e) {
              resolve(undefined);
            }
          })
          .catch((err) => reject(err));
      });
    },
  },
  getters: {},
};
